<template>
  <div class="document-tab-content" :data-document-status="status" :data-readonly="!canEdit"
       :data-work-mode="workMode">
    <div class="toolbar toolbar-document">
      <div class="toolbar-content" v-if="documentObject">
        <div class="left">
          <template v-if="inEditWorkMode">
            <simple-dropdown v-if="enableSerial" :click-dropdown-menu-to-hide="false" :dropdown-arrow="true"
                             @dropdownMenuShown="loadSerialBoost">
              <template v-slot:triggerButtonContent>
                <button class="d-flex align-items-center">
                                    <span class="mr-2"><span>Serial Boost</span><span v-if="serialBoostLength!==null"> ({{
                                        serialBoostLength
                                      }})</span></span><i
                    class="general-icon general-icon-expand"></i>
                </button>
              </template>
              <template v-slot:dropdownMenu>
                <div class="dropdown-content">
                  <serial-boost ref="serialBoost" :global-document-id="globalDocumentId"
                                :project-id="projectId"
                                @loadEnd="onSerialBoostLoadEnd"></serial-boost>
                </div>
              </template>
            </simple-dropdown>
            <div class="switchers">
              <simple-dropdown ref="statusDropdown" :dropdown-arrow="true" :mouse-enter-to-show="true"
                               class="status-description-dropdown" :alignment="1">
                <template v-slot:triggerButtonContent>
                  <div class="switchers-content">
                    <button class="switch-button" v-for="(item,index) in documentStatusOptions"
                            :key="index" :data-status="item.value"
                            @click.stop="vChangeStatus(item.value)"
                            :class="{active: status===item.value}">
                      {{ item.label }}
                    </button>
                  </div>
                </template>
                <template v-slot:dropdownMenu>
                  <div class="dropdown-content">
                    <div class="status-description">
                      <p><span
                          v-if="status === '1'">Todo {{
                          describeUsername(statusSetBy) ? ('by ' + describeUsername(statusSetBy)) : 'Initially'
                        }}</span>
                        <span v-if="status === '2'">Done by {{
                            describeUsername(statusSetBy, 'Unknown')
                          }}</span>
                        <span v-if="status === '3'">Skipped by {{
                            describeUsername(statusSetBy, 'Unknown')
                          }}</span>
                        <span v-if="statusSetTime"> at {{
                            describeUnixTs(statusSetTime)
                          }}</span>
                      </p>
                    </div>
                  </div>
                </template>
              </simple-dropdown>
            </div>
            <div v-if="canEdit" class="button-container">
              <template v-if="canSubmit">
                <button class="button-primary button-submit" @click="onSubmitButtonClicked">Submit
                </button>
              </template>
              <template v-else-if="submitting">
                <button class="disabled">Submitting...</button>
              </template>
              <template v-else>
                <button class="button-no-changes">No Changes</button>
              </template>
            </div>
            <template v-else>
              <simple-dropdown :dropdown-arrow="true" class="readonly-indicator-dropdown" :alignment="1"
                               :mouse-enter-to-show="true">
                <template v-slot:triggerButtonContent>
                                    <span class="readonly-indicator"><i
                                        class="gf gf-lock"></i><span>READ ONLY</span></span>
                </template>
                <template v-slot:dropdownMenu>
                  <div class="dropdown-content">
                    <div class="readonly-description">
                      <p class="mb-2"><strong>Cannot Submit Changes</strong></p>
                      <pre class="mb-2">{{ getReadonlyExplanation() }}</pre>
                      <div>
                        <button class="button-dangerous" @click="forceEnterDocument">Force Enter
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </simple-dropdown>
            </template>
          </template>
          <template v-else>
            <div class="status-description-inline mr-auto">
                            <span v-if="status === '1'"><strong>Todo</strong> {{
                                describeUsername(statusSetBy) ? ('by ' + describeUsername(statusSetBy)) : 'Initially'
                              }}</span>
              <span v-if="status === '2'"><strong>Done</strong> by {{
                  describeUsername(statusSetBy, 'Unknown')
                }}</span>
              <span v-if="status === '3'"><strong>Skipped</strong> by {{
                  describeUsername(statusSetBy, 'Unknown')
                }}</span>
              <span v-if="statusSetTime"> at {{ describeUnixTs(statusSetTime) }}</span>
            </div>
          </template>
        </div>
        <div class="right">
          <button @click="$refs.documentViewer.showFindText(true)">Find...</button>
          <!--                    <select v-if="sourceOptions.length" @change="sourceSelectChanged" class="ml-auto">-->
          <!--                        <option selected disabled value="">Source</option>-->
          <!--                        <option v-for="(option,index) in sourceOptions" :key="index" :value="option.value">-->
          <!--                            {{option.label}}-->
          <!--                        </option>-->
          <!--                    </select>-->
          <simple-dropdown v-if="sourceOptions.length" :click-dropdown-menu-to-hide="true"
                           :dropdown-arrow="true" class="ml-auto">
            <template v-slot:triggerButtonContent>
              <button class="d-flex align-items-center">
                <span class="mr-2"><span>Source</span></span><i
                  class="general-icon general-icon-expand"></i>
              </button>
            </template>
            <template v-slot:dropdownMenu>
              <div class="dropdown-content">
                <ul>
                  <li v-for="(item,index) in sourceOptions" :key="index">
                    <button @click="openSourceLink(item.value)">{{ item.label }}</button>
                  </li>
                </ul>
              </div>
            </template>
          </simple-dropdown>
          <simple-dropdown :click-dropdown-menu-to-hide="true"
                           :alignment="1"
                           class="more-actions-dropdown">
            <template v-slot:triggerButtonContent>
              <span class="dots-vertical"><i></i><i></i><i></i></span>
              <!--                            <button>More...</button>-->
            </template>
            <template v-slot:dropdownMenu>
              <div class="dropdown-content">
                <ul class="more-actions">
                  <li v-if="activeDocumentViewer!==viewerHTML">
                    <button @click="setActiveDocumentViewer(viewerHTML)">Switch to Responsive Viewer
                    </button>
                  </li>
                  <li v-if="activeDocumentViewer!==viewerPDF">
                    <button @click="setActiveDocumentViewer(viewerPDF)">Switch to PDF Viewer
                    </button>
                  </li>
                  <li class="separator"></li>
                  <li>
                    <button @click="reloadDocument(true)">Reload Document</button>
                  </li>
                </ul>
              </div>
            </template>
          </simple-dropdown>
        </div>
      </div>
    </div>
    <div class="main-area" v-if="documentObject">
      <document-control-panel :document-object="documentObject" ref="documentControlPanel" :status="status"
                              :status-set-by="statusSetBy" :can-edit="canEdit"
                              :project-id="projectId"
                              @valueChanged="valueChanged"
                              @highlightTextInViewer="highlightTextInViewer"
      ></document-control-panel>
      <document-viewer :html-src="htmlSrc" ref="documentViewer"
                       v-if="activeDocumentViewer===viewerHTML"></document-viewer>
      <document-viewer-pdfjs :pdf-src="pdfSrc" ref="documentViewer"
                             v-if="activeDocumentViewer===viewerPDF"></document-viewer-pdfjs>
    </div>
    <div class="main-area main-area-message" v-if="isLoading">
      <div class="global-message-box">
        <div class="spinner">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
      </div>
    </div>
    <div class="main-area main-area-message" v-if="isHavingProblemLoading">
      <div class="global-message-box">
        <div class="text-center">
          <h1>There was something not right while loading the document!</h1>
          <button @click="reloadDocument(true)" style="margin-top: 0.25rem">Reload Document</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {buildRequestURL, openDocument, submitDocumentChanges} from "@/apis";

import {
  projectIdToName,
  documentStatusOptions,
  documentSourceKey2Label,
  documentSourceKeys, projectIdToTemplate, statusIds,
} from "@/config";
import DocumentControlPanel from "@/components/DocumentControlPanel";
import {
  authHelper,
  deepCompare,
  placeholderDateUnix,
  userSettingsManager,
  workModeEdit,
  workModeRead,
  validateFields
} from "@/utils";
import {Promise} from 'es6-promise-polyfill'
import SimpleDropdown from "@/components/SimpleDropdown";
import SerialBoost from "@/components/SerialBoost";
import DocumentViewerPdfjs from "@/components/DocumentViewerPDFJS";
import DocumentViewer from "@/components/DocumentViewer";

const rejectReasons = {
  validationNotPass: 1,
  connectionError: 2,
  unfilledCompulsoryNotAllowed: 3,
  lostEditPower: 4,
};

const viewerHTML = 'html';
const viewerPDF = 'pdf';

export default {
  name: "DocumentTabContent",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    DocumentViewer, DocumentViewerPdfjs, SerialBoost, SimpleDropdown, DocumentControlPanel
  },
  props: {
    globalDocumentId: String,
    projectId: String,
  },
  data() {
    return {
      documentStatusOptions,
      documentSourceKey2Label,
      documentSourceKeys,
      status: null,
      statusSetBy: null,
      statusSetTime: null,
      statusSetAt: null,
      documentId: null,
      sources: null,
      htmlSrc: null,
      pdfSrc: null,
      customData: null,
      documentObject: null,
      existsChangedValue: false,
      isLoading: false,
      isInitialized: false,
      isHavingProblemLoading: false,
      serialBoostLength: null,
      canEdit: false,
      currentlyEditedBy: null,
      currentlyEditedToken: null,
      viewerHTML: viewerHTML,
      viewerPDF: viewerPDF,
      activeDocumentViewer: null,
      submitting: false,
    }
  },
  created() {
    this.startLoadingDocument();
  },
  methods: {
    getReadonlyExplanation() {
      let s = 'The document is actively edited by ';
      if (this.currentlyEditedBy === authHelper.getUserInfo().username) {
        s += 'me \nfrom another session.'
      } else {
        s += this.currentlyEditedBy;
      }

      return s;
    },
    forceEnterDocument() {
      if (!window.confirm('Are you sure you want to force enter?')) {
        return;
      }
      this.reloadDocument(false, true);
    },
    reloadDocument(confirm, forceEnter) {
      if (confirm && this.canSubmit && !window.confirm('There are unsaved changes. Are you sure to continue?')) {
        return;
      }

      this.documentObject = null;
      this.existsChangedValue = false;

      this.$nextTick(() => {
        this.startLoadingDocument(this.currentlyEditedToken, forceEnter).then(() => {
          this.valueChanged();
        });
      })
    },
    onSerialBoostLoadEnd(showingResults, results) {
      if (showingResults) {
        this.serialBoostLength = results.length;
      } else {
        this.serialBoostLength = null
      }
    },
    startLoadingDocument(editToken, forceEnter) {
      if (this.isLoading) {
        return Promise.reject();
      }

      this.$emit('documentStartLoading', this.globalDocumentId);

      this.setLoadingStatus(true, false, false);
      return openDocument(this.globalDocumentId, editToken, forceEnter).then((r) => {
        if (this.projectId !== r['project_id']) {
          this.setLoadingStatus(false, false, true);
          this.$emit('documentFetchingError', this.globalDocumentId);
          return;
        }
        this.setLoadingStatus(false, true, false);
        this.renderDocument(r);
      }).catch((err) => {
        this.setLoadingStatus(false, false, true);
        this.$emit('documentFetchingError', this.globalDocumentId);
        this.handleServerSideError(err).catch(() => {

        })
      })
    },
    setLoadingStatus(isLoading, isInitialized, isHavingProblemLoading) {
      this.isLoading = isLoading;
      this.isInitialized = isInitialized;
      this.isHavingProblemLoading = isHavingProblemLoading;
    },
    highlightTextInViewer(text) {
      this.$refs.documentViewer.highlightText(text);
    },
    checkCloseable() {
      return !this.canSubmit;
    },
    valueChanged() {
      this.$nextTick(() => {
        const documentControlPanel = this.$refs.documentControlPanel;
        const current = documentControlPanel.buildCurrentSavableObject();
        const old = documentControlPanel.getSolidSavableObject();
        this.existsChangedValue = !deepCompare(current, old);
      })
    },
    onSubmitButtonClicked() {
      if (!this.canSubmit) {
        return;
      }

      this.submitting = true;
      this.submitChanges(this.status === statusIds.done, this.status !== statusIds.skipped).then(() => {
        if (this.enableSerial) {
          this.updateSerialManagerAndCards();
        }
      }).catch(r => {
        if (r.reason === rejectReasons.validationNotPass) {
          if (r.errors) {
            const e = r.errors[0].items[0];
            this.highlightEventAndProperty(e.eventId, e.fieldId)
          }
          setTimeout(() => {
            alert('Your data does not pass the validation. Here are more details.\n' + r.detail)
          }, 0)
        } else if (r.reason === rejectReasons.connectionError) {
          alert('There was something not right with the connection with the server.')
        } else if (r.reason === rejectReasons.lostEditPower) {
          alert('You cannot make changes now. Please reload the document!')
        } else {
          alert('There was something not right while submitting changes!')
          throw r;
        }
      }).then(() => {
        this.submitting = false;
      })
    },
    handleValidatedResult(validatedResult) {
      if (validatedResult.ok) {
        return Promise.resolve();
      }

      return Promise.reject({
        reason: rejectReasons.validationNotPass,
        detail: validatedResult.reason,
        errors: validatedResult.errors,
      })
    },
    /**
     * post process the diffBetweenEvents object.
     * Currently there's only one thing to do: replace the date placeholder "1111-11-11" with null
     */
    postProcessDiffBetweenEvents(diffBetweenEvents) {
      const {updated, newed} = diffBetweenEvents;
      const eventObjects = updated.concat(newed);
      const {fieldIdToSchema} = this;
      eventObjects.forEach(item => {
        const {values} = item;
        for (const fieldId in values) {
          if (values.hasOwnProperty(fieldId)) {
            const fieldSchema = fieldIdToSchema[fieldId];
            const fieldValue = values[fieldId];
            if (fieldValue !== null && fieldSchema.data_type === 'range' && fieldSchema.range_entry_type === 'date') {
              let dateFrom = fieldValue.from;
              let dateTo = fieldValue.to;
              if (dateFrom === placeholderDateUnix) {
                dateFrom = null;
                fieldValue.from = null;
              }
              if (dateTo === placeholderDateUnix) {
                dateTo = null;
                fieldValue.to = null;
              }
              if (dateFrom === null && dateTo === null) {
                values[fieldId] = null;
              }
            }
          }
        }
      })
    },
    /**
     * Submit changes in this document
     * @param checkCompulsory: whether to check if all compulsory fields are filled
     * @param checkStrictValidation: whether to perform strict validation for the data
     * @returns {Promise<any> | * | PromiseLike<any>} May be resolved or rejected
     */
    submitChanges(checkCompulsory, checkStrictValidation) {
      const documentControlPanel = this.$refs.documentControlPanel;
      const current = documentControlPanel.buildCurrentSavableObject();

      const validatedResult = this.validEventObjects(current.events, checkCompulsory, checkStrictValidation);

      return this.handleValidatedResult(validatedResult).then(() => {
        const old = documentControlPanel.getSolidSavableObject();
        const diffBetweenEvents = this.getDiffBetweenEvents(current.events, old.events);

        this.postProcessDiffBetweenEvents(diffBetweenEvents);

        const detail = {diffBetweenEvents};

        if (current.status !== old.status || current.statusSetBy !== old.statusSetBy) {
          detail.statusChangedInto = current.status;
        }

        return submitDocumentChanges(this.globalDocumentId, detail, this.currentlyEditedToken).then((r) => {
          if (r.error) {
            alert(r.error);
            return;
          }

          documentControlPanel.changeEventIdsWithMaps(r['temp_event_id_2_real_event_id'] || {});
          documentControlPanel.updateEventsUserRelatedDataWithMaps(r['user_related_event_data'] || {});

          if (detail.statusChangedInto) {
            this.statusSetTime = r['updated_status_set_time'];
          }

          const savableObject = documentControlPanel.buildCurrentSavableObject();
          documentControlPanel.setSolidSavableObject(savableObject);

          const eventId2Values = {};
          savableObject.events.forEach(v => {
            eventId2Values[v.event_id] = v.values;
          });

          let eventObjects;
          if (this.enableSerial) {
            if (r['document_nature'] && r['document_nature']['modified']) {
              this.$set(this.documentObject['custom_data'], 'nature', r['document_nature']['value']);
              this.loadSerialBoost();
            }
            eventObjects = [];
            this.documentObject['serials'].forEach(serialObject => {
              (serialObject['events'] || []).forEach(eventObject => {
                eventObjects.push(eventObject);
              })
            });
          } else {
            eventObjects = this.documentObject['events'];
          }

          eventObjects.forEach(v => {
            const newVal = eventId2Values[v.event_id];
            if (newVal) {
              v.values = newVal;
            }
          });

          this.valueChanged();
        }).catch((err) => {
          return this.handleServerSideError(err).catch(() => {
            if (err && err.status === 400) {
              return Promise.reject({reason: rejectReasons.lostEditPower, err})
            }
            return Promise.reject({reason: rejectReasons.connectionError, err})
          })
        })
      });
    },
    getDiffBetweenEvents(current, old) {
      const updated = [];
      const deleted = [];
      const newed = [];

      const currentEventId2Event = {}, oldEventId2Event = {};
      current.forEach(value => {
        currentEventId2Event[value.event_id] = value;
      })
      old.forEach(value => {
        oldEventId2Event[value.event_id] = value;
      })
      for (let eventId in oldEventId2Event) {
        if (oldEventId2Event.hasOwnProperty(eventId)) {
          if (currentEventId2Event.hasOwnProperty(eventId)) {
            if (!deepCompare(currentEventId2Event[eventId], oldEventId2Event[eventId])) {
              updated.push(currentEventId2Event[eventId]);
            }
          } else {
            deleted.push(eventId);
          }
        }
      }
      for (let eventId in currentEventId2Event) {
        if (currentEventId2Event.hasOwnProperty(eventId) && !oldEventId2Event.hasOwnProperty(eventId)) {
          newed.push(currentEventId2Event[eventId]);
        }
      }
      return {updated, deleted, newed};
    },
    getDiffBetweenSerialIds(current, old) {
      const newlyBound = [];
      const unbound = [];
      current.forEach(value => {
        if (old.indexOf(value) === -1) {
          newlyBound.push(value);
        }
      });
      old.forEach(value => {
        if (current.indexOf(value) === -1) {
          unbound.push(value);
        }
      });
      return {newlyBound, unbound};
    },
    /**
     * Preprocess the document object.
     * For example, remember the date range placeholder? Need to set the date range placeholder.
     * @param document
     */
    preprocessDocumentObject(document) {
      const {status, serials, events} = document;
      const {fieldIdToSchema} = this;
      const isDoneDocument = status === statusIds.done;

      const eventObjectHandler = (eventObject) => {
        const {values} = eventObject;
        if (!values) {
          return;
        }
        for (const fieldId in values) {
          if (values.hasOwnProperty(fieldId) && fieldIdToSchema.hasOwnProperty(fieldId)) {
            const fieldSchema = fieldIdToSchema[fieldId];
            const fieldValue = values[fieldId];
            if (fieldSchema.data_type === 'range' && fieldSchema.range_entry_type === 'date') {
              // this is a date range field
              if (fieldValue) {
                // if from or to is null, set the placeholder
                if (fieldValue.from === null) {
                  fieldValue.from = placeholderDateUnix;
                }
                if (fieldValue.to === null) {
                  fieldValue.to = placeholderDateUnix;
                }
              } else if (fieldSchema.is_compulsory && isDoneDocument) {
                // if it's null and the field is required, we need to set the placeholder
                // eslint-disable-next-line
                values[fieldId] = {
                  from: placeholderDateUnix,
                  to: placeholderDateUnix
                }
              }
            }
          }
        }
      }
      if (serials) {
        serials.forEach(serialObject => {
          if (serialObject.events) {
            serialObject.events.forEach(eventObjectHandler);
          }
        })
      }
      if (events) {
        events.forEach(eventObjectHandler);
      }
    },
    renderDocument(document) {
      this.preprocessDocumentObject(document);
      this.status = document['status'];
      this.statusSetBy = document['status_set_by'];
      this.statusSetTime = document['status_set_time'];
      this.documentId = document['document_id'];
      this.sources = document['sources'];
      this.canEdit = document['can_edit'];
      this.currentlyEditedBy = document['currently_edited_by'];
      this.currentlyEditedToken = document['currently_edited_token'];

      this.htmlSrc = document['html_src'];

      const pdfFileURL = buildRequestURL(`/pdf?global_document_id=${this.globalDocumentId}`);

      this.pdfSrc = `/pdfjs-build/generic/web/viewer.html?file=${encodeURIComponent(pdfFileURL)}#page=1`;

      this.customData = document['custom_data'];

      this.documentObject = document;

      this.$nextTick(() => {
        this.$emit('documentLoaded', this.globalDocumentId, {
          documentId: document['document_id'],
          currentlyEditedToken: this.currentlyEditedToken
        });
      })
    },
    sourceSelectChanged(event) {
      const target = event.currentTarget;
      const sourceKey = target.value;
      if (!sourceKey) {
        return;
      }
      target.value = '';
      if (this.sources && sourceKey in this.sources) {
        const link = this.sources[sourceKey];
        window.open(link, '_blank');
      }
    },
    openSourceLink(sourceKey) {
      if (this.sources && sourceKey in this.sources) {
        const link = this.sources[sourceKey];
        window.open(link, '_blank');
      }
    },
    vChangeStatus(newStatus) {
      if (this.status === newStatus) {
        return;
      }

      this.status = newStatus;
      this.statusSetBy = authHelper.getUserInfo().username;
      this.statusSetTime = null;

      this.$nextTick(() => {
        this.valueChanged();
        this.$refs.statusDropdown.reposition();
      })
    },
    getEventLocationDescription(eventId, i) {
      if (this.enableSerial) {
        const serials = this.documentObject['serials'];
        for (let i = 0; i < serials.length; i++) {
          const events = serials[i]['events'];
          for (let j = 0; j < events.length; j++) {
            const event = events[j];
            if (event['event_id'] === eventId) {
              return `Serial ${i + 1} > Event ${j + 1}`
            }
          }
        }
      }
      return 'Event ' + (i + 1)
    },
    validEventObjects(eventObjects, checkCompulsory, checkStrictValidation) {
      const errors = [];
      const {projectId} = this;

      eventObjects.forEach((value, i) => {
        const eventId = value['event_id'];
        const values = value['values'];
        const eventLocation = this.getEventLocationDescription(eventId, i);
        const fields = this.projectFieldSchemas;
        const items = [];
        let skipCompulsoryCheck = false;

        if (values === null) {
          items.push({
            explanation: 'The item is not complete'
          })
        } else {
          if (projectId === '11') {
            // Issue of Debt
            const vStatus = values['2'];
            if (vStatus && vStatus.indexOf("Proposed") >= 0) {
              skipCompulsoryCheck = true;
            }
          }
          // validate fields
          items.push(...validateFields(fields, eventId, values, ((!skipCompulsoryCheck) && checkCompulsory), checkStrictValidation))
          // end of validate fields
        }

        if (items.length) {
          errors.push({
            path: eventLocation,
            items
          })
        }
      })

      let reason = '';

      errors.forEach(item => {
        reason += `\n${item.path}:`;
        item.items.forEach(item1 => {
          reason += `\n` +
              ('fieldIndex' in item1 ? (`In property "${item1.fieldIndex + 1}. ${item1.fieldName}", `) : '') +
              `${item1.explanation}.`;
        })
      });

      return {
        ok: !errors.length,
        reason,
        errors,
      }
    },
    highlightEventAndProperty(eventId, fieldId) {
      this.$refs.documentControlPanel.highlightEventAndProperty(eventId, fieldId);
    },
    highlightSerial(serialId) {
      this.$refs.documentControlPanel.highlightSerial(serialId);
    },
    updateSerialManagerAndCards() {
      this.$refs.documentControlPanel.updateSerialManagerAndCards();
    },
    loadSerialBoost() {
      this.$refs.serialBoost.loadData();
    },
    setActiveDocumentViewer(v) {
      this.activeDocumentViewer = v;
      userSettingsManager.setLastSelectedViewer(v);
    }
  },
  computed: {
    projectName() {
      return projectIdToName[this.projectId]
    },
    availableSourceKeys() {
      return this.documentSourceKeys.filter(item => (this.sources && item in this.sources))
    },
    sourceOptions() {
      return this.availableSourceKeys.map(v => ({value: v, label: documentSourceKey2Label[v]}))
    },
    canSubmit() {
      return this.canEdit && this.existsChangedValue && !this.submitting;
    },
    projectFieldsTemplate() {
      return projectIdToTemplate[this.projectId];
    },
    projectFieldSchemas() {
      return this.projectFieldsTemplate['fields'] || [];
    },
    fieldIdToSchema() {
      const fieldIdToSchema = {};
      this.projectFieldSchemas.forEach(item => {
        fieldIdToSchema[item.field_id] = item;
      });
      return fieldIdToSchema;
    },
    workMode() {
      return userSettingsManager.getWorkMode();
    },
    inEditWorkMode() {
      return this.workMode === workModeEdit;
    },
    inReadWorkMode() {
      return this.workMode === workModeRead;
    },
    enableSerial() {
      const projectTemplate = projectIdToTemplate[this.projectId];
      return projectTemplate && projectTemplate['enable_serial'];
    },
  },
  watch: {
    canSubmit: {
      handler(newVal) {
        this.$store.commit('setDocumentCanSubmit', {
          globalDocumentId: this.globalDocumentId,
          canSubmit: newVal,
          projectId: this.projectId,
        })

      },
      immediate: true
    },
    workMode: {
      handler(newVal) {
        if (newVal === workModeRead) {
          this.activeDocumentViewer = viewerPDF;
        } else if (newVal === workModeEdit) {
          this.activeDocumentViewer = userSettingsManager.getLastSelectedViewer() || viewerHTML;
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/variables";

.document-tab-content {
  height: calc(100% - 36px);
}

.main-area {
  height: calc(100% - 36px);
  display: flex;

  .control-panel {
    width: $control-panel-width;
    height: 100%;
    //box-shadow: 4px 0 8px -3px rgba(0,0,0,0.25), 0 0 6px 0 rgba(0,0,0,0.1);
    position: relative;
    z-index: 9;
    border-right: 1px solid #dcdcdc;
  }

  .document-viewer {
    width: $document-viewer-width;
    height: 100%;
  }

  &.main-area-message {
    z-index: 50;
    position: relative;
    background-color: #f3f3f3;;
  }
}

.toolbar-document {
  background-color: #f3f3f3;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25), 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  height: 36px;
  display: flex;
  align-items: center;
  z-index: 20;

  .switchers {
    margin: 0 auto;

    .switchers-content {
      display: flex;
      align-items: center;
      background-color: #e0e0e0;
      border-radius: 4px;
      border: 1px solid #ccc;
      padding: 0.2rem 0.2rem;

      &:hover {
        border: 1px solid #999;
      }
    }

    button {
      margin: 0 0.25rem;
      font-size: 13px;
      padding: 0.1rem 0.6rem;

      &:focus {
        box-shadow: none;
      }

      &.active {
        cursor: not-allowed;
      }

      &[data-status="1"].active {
        background-color: #555555;
        color: white;
      }

      &[data-status="2"].active {
        background-color: $primary-green;
        color: white;
      }

      &[data-status="3"].active {
        background-color: $primary-orange;
        color: white;
      }
    }
  }

  .button-container {
    min-width: 104px;
    text-align: right;
  }

  .toolbar-content {
    flex: 1 auto;

    .left, .right {
      display: flex;
      align-items: center;
    }

    .left {
      width: $control-panel-width;
      border-right: 1px solid lightgray;
      padding: 0 1rem 0 0.5rem;
    }

    .right {
      width: $document-viewer-width;
      padding: 0 0.5rem 0 1rem;

      .zoom-helper {
        margin: 0 auto;

        button {
          margin: 0 0.25rem;
        }
      }
    }
  }

  .readonly-indicator {
    display: flex;
    align-items: center;
    border: 1px solid $warning-red;
    color: $warning-red;
    border-radius: 4px;
    padding: 1px 7px 1px 4px;
    font-weight: 500;

    i {
      font-size: 1rem;
      margin-right: 0.1rem;
    }
  }
}

button.button-no-changes {
  opacity: 0.5;
  outline: none;
  pointer-events: none;
}
</style>
<style lang="scss">
@import "../assets/variables";

.document-tab-content {
  &[data-document-status="2"] {
    .properties-form.event {
      & > .property-item.is-empty.is-compulsory {
        position: relative;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: -0.5rem;
          right: 0;
          bottom: -0.5rem;
          left: -0.8rem;
          border-radius: 6px;
          border: 4px solid rgba($primary-orange, 0.32);
          pointer-events: none;
        }

        .property-label {
          &:before {
            /*content: '!';*/
            color: $primary-orange;
          }
        }
      }
    }
  }

  &[data-document-status="1"], &[data-document-status="2"] {
    .properties-form.event {
      & > .property-item.is-empty.is-compulsory {
        & > .property-label {
          & > .label {
            color: $warning-red;
          }
        }
      }
    }
  }

  .status-description-dropdown {
    margin: 0 0.25rem;

    .trigger {
      cursor: default;

      .dots {
        background-color: #d0d0d0;
      }
    }
  }

  .more-actions-dropdown {
    margin: 0 0 0 0.5rem;

    .trigger {
      cursor: pointer;

      button {
        box-shadow: none;
      }

      .dots-vertical {
        padding: 0;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        i {
          width: 2px;
          height: 2px;
          border-radius: 50%;
          background-color: black;

          &:not(:last-child) {
            margin-bottom: 2px;
          }
        }
      }

      button {
        &:active {
          background-color: #c0c0c0;
          color: white;
          border: 1px solid #a0a0a0;
        }
      }

      &:hover {
        .dots-vertical {
          background-color: #777777;

          i {
            background-color: white;
          }
        }
      }
    }

    &.active {
      .trigger {
        button {
          box-shadow: none;
          background-color: #c0c0c0;
          color: white;
          border: 1px solid #a0a0a0;
        }

        .dots-vertical {
          background-color: #333333;

          i {
            background-color: white;
          }
        }
      }
    }
  }

  .edit-sensitive-container.cannot-edit {
    .edit-involved-button {
      display: none;
    }
  }

  &[data-work-mode="edit"][data-readonly="true"] {
    .switchers-content {
      pointer-events: none;
      opacity: 0.5;
    }

    .tabs-bar {
      .more-dropdown-button, .add-button {
        display: none;
      }
    }

    .tab-content-container, .tabs-bar, .toolbar-content {
      .edit-involved-button {
        pointer-events: none;
        opacity: 0.5;
      }
    }

    .properties-form .property-item {
      .property-control {
        opacity: 0.5;

        input, select, textarea {
          pointer-events: none;
        }

        .box {
          textarea {
            display: none;
          }

          .entity-item .item-content .remove-button {
            display: none;
          }
        }
      }

      .value-candidates, .shortcuts {
        pointer-events: none;
        opacity: 0.5;
      }

      .more-dropdown-button {
        display: none;
      }
    }
  }
}

.status-description {
  padding: 0.5rem 1rem;

  p, pre {
    margin-top: 0;
    margin-bottom: 0;
    font-family: inherit;
  }
}

.status-description-inline {
  background: #e0e0e0;
  padding: 0.15rem 0.5rem;
  border-radius: 2px;

  strong {
    font-weight: 500;
  }
}

.readonly-description {
  padding: 0.5rem 1rem;
  text-align: center;

  p, pre {
    margin-top: 0;
    font-family: inherit;
  }
}
</style>
